import React, { useState, useRef, useContext, useEffect, useCallback } from "react";
import { Input, Popover, Tooltip } from "antd";
import './HashTagInput.css';
import _ from "lodash";
import { Label } from "reactstrap";

const HashTagInput = ({triggerChar,options,value,setValue,taskFields}) => {
  // const [value, setValue] = useState("");
  const [showPopover, setShowPopover] = useState(false);
  const [filteredOptions,setFilteredOptions] = useState([]);
  const [taskOptions,setTaskOptions] = useState([]);
  const [searchTerm,setSearchTerm] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  // const [options,setOptions] = useState([])
  const inputRef = useRef(null);
  const inputSearchRef = useRef(null);
  useEffect(data=>{
    // setFilteredOptions(options || [])
    let arr = [];
    if(options){
      arr = [...options];
    } 
    if(taskFields){
      let fields=[...taskFields];
      if(searchTerm){
        fields = fields.filter((option) =>
          option?.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      setTaskOptions(fields);
    }
    if(searchTerm){
      arr = arr.filter((option) =>
        option?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredOptions(arr);

  },[options,searchTerm,taskFields])
  
  const handleChange = (e) => {
    const inputValue = e.target.value;
    const cursorPos = e.target.selectionStart;
    setValue(inputValue);

    if (inputValue[cursorPos - 1] === triggerChar) {
      setShowPopover(true);
      setCursorPosition(cursorPos); 
    } else {
      setShowPopover(false);
    }
  };

  const handleSelect = (option) => {
    const newValue =
      value.slice(0, cursorPosition - 1) + 
      "{"+
      option.field+
      "}"+
      value.slice(cursorPosition);
    setValue(newValue);
    setShowPopover(false);
    inputRef.current.focus();
  };

  const content = (
    <div>
      <Input
        placeholder="Search..."
        ref={inputSearchRef}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "8px", width: "100%" }}
      />
      <div>
        <Label style={{background: 'whitesmoke',width: '100%',borderRadius: "5px",color: '#5b6cb2',fontWeight: '600'}}> Deal Fields </Label>
        {filteredOptions?.length > 0 ? (
          filteredOptions?.map((option) => (
            <div
              key={option.id}
              onClick={() => handleSelect(option)}
              style={{
                padding: "4px 8px",
                cursor: "pointer",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              {option.name}
            </div>
          ))
        ) : (
          <div style={{ padding: "8px", textAlign: "center", color: "#888" }}>
            No options found
          </div>
        )}
        {taskOptions && taskOptions?.length > 0 && <Label style={{background: 'whitesmoke',width: '100%',borderRadius: "5px",color: '#5b6cb2',fontWeight: '600'}}> Task Fields </Label>}
          {taskOptions?.length > 0 && (
            taskOptions?.map((option) => (
              <div
                key={option.id}
                onClick={() => handleSelect(option)}
                style={{
                  padding: "4px 8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                {option.name}
              </div>
            ))
          )}
      </div>
    </div>

  );

  return (
    <div>
      <Popover
        content={content}
        overlayClassName="Field-Picker-Popover"
        trigger="click"
        open={showPopover}
        destroyTooltipOnHide
        placement="top"
      >
        <Tooltip title={"Type '{' to include deal fields"} overlayInnerStyle={{color:"black"}} color="white">
          <Input
            ref={inputRef}
            className="Global-Text-Color"
            value={value}
            onChange={handleChange}
            placeholder="Type '{' to include deal fields"
          // style={{ width: "300px" }}
          />
        </Tooltip>
      </Popover>
    </div>
  );
};

export default HashTagInput;
